// Turks (tr-TR), remindersApp: zelfde vorm als remindersApp.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appRemindersTr = {
    section: 'Hatırlatmalar',
    sectionHint: 'Tablette ekstra bir uyarı: ekran çocuğunu adıyla, büyük bir resimle çağırır. Yanına alınacaklar için bir işaretleme listesiyle.',
    allDayHint: 'Hatırlatmalar saati olan etkinliklerde çalışır.',
    add: 'Hatırlatma',
    addTitle: 'Yeni hatırlatma',
    editTitle: 'Hatırlatmayı değiştir',
    edit: 'Değiştir',
    remove: 'Kaldır',
    removed: 'Hatırlatma kaldırıldı',
    confirmAdd: 'Hatırlatmayı ekle',
    confirmSave: 'Hatırlatmayı güncelle',
    closeForm: 'Formu bu hatırlatma olmadan kapat',
    max: 'Etkinlik başına en fazla 5 hatırlatma.',
    when: 'Ne zaman',
    customWhen: 'Özel süre',
    customLabel: 'Kaç dakika önce',
    customHint: '1 ile 1440 dakika arası (bir gün).',
    offsetInvalid: '1 ile 1440 dakika arası seç.',
    text: 'Metin',
    textPlaceholder: 'Antrenmana hazırlan',
    textRequired: 'Kısa bir metin yaz.',
    textTooLong: 'En fazla 60 karakter.',
    suggestions: 'Öneriler',
    picto: 'Simge',
    forWho: 'Kimin için',
    everyone: 'Etkinlikteki herkes',
    everyoneKids: 'Tüm çocuklar',
    whoRequired: 'Bu hatırlatmanın kimin için olduğunu seç.',
    prunedChanged: '{names} artık katılmıyor; "{title}" hatırlatması güncellendi.',
    prunedChangedMany: '{names} artık katılmıyor; "{title}" hatırlatması güncellendi.',
    prunedRemoved: '{names} artık katılmıyor; "{title}" hatırlatması kaldırıldı.',
    prunedRemovedMany: '{names} artık katılmıyor; "{title}" hatırlatması kaldırıldı.',
    prunedThisHint: 'Kaydederken "Sadece bu sefer"i seçersen diğer seferlerin hatırlatmaları olduğu gibi kalır.',
    allDayDrop: 'Tüm gün süren etkinlikte tablet çağırmaz: kaydedince bu hatırlatmalar kalkar.',
    and: 've',
    speak: 'Sesli oku',
    speakHint: 'Tablet adı ve metni yüksek sesle söyler.',
    sound: 'Ses',
    soundHint: 'Yumuşak bir zil sesi (sessiz saatlerde çalmaz).',
    preview: 'Tablet böyle çağırır',
    previewOk: 'Tamam',
    previewContext: '{title}, saat {time}',
    previewNoTitle: 'Etkinlik',
    minutes: '{count} dk',
    hours: '{count} saat',
    hoursMinutes: '{hours} saat {minutes} dk',
    before: '{when} önce',
    chip: '{when} önce · {title}',
    chipLabel: '{when} önce hatırlatma: {title}',
    skipOnce: 'Sadece bu sefer olmasın',
    skipOnceLabel: '"{title}" hatırlatması sadece bu sefer olmasın',
    skipOnceDone: 'Tablet bu sefer çağırmayacak: {title}',
    skippedChip: 'Bu sefer yok',
    unskip: 'Yine de çağır',
    unskipLabel: '"{title}" hatırlatmasıyla bu sefer yine de çağır',
    unskipDone: 'Tablet bu sefer yine çağıracak: {title}',
    suggestTraining: 'Antrenmana hazırlan',
    suggestSwim: 'Yüzme çantasını hazırla',
    suggestBag: 'Çantanı hazırla',
    suggestShoes: 'Ayakkabı ve montunu giy',
    suggestGeneric: 'Hazırlan: {title}',
    suggestGenericEmpty: 'Hazırlan',
    taskTime: 'Saat',
    taskTimeHint: 'Boş bırakılabilir.',
    taskAnnounce: 'Panoda duyur',
    taskAnnounceHint: 'O saatte tablet zil çalar ve kimin ne yapacağını söyler. Sessiz saatlerde ve gece sessizdir.',
};
//# sourceMappingURL=remindersApp.tr.js.map